import React from "react";
import PropTypes from "prop-types";
import GnomadHistogram from ".";
import { createHistogram } from "../helpers";

const title = (isMito, nonpar, ageHistHomEmpty) => {
  if (isMito) {
    return "Homoplasmic";
  }
  if (nonpar && nonpar === 1 && !ageHistHomEmpty) {
    return "Homozygotes & Hemizygotes";
  }
  if (nonpar !== 1 && !ageHistHomEmpty) {
    return "Homozygotes";
  }
  return "";
};

const Histograms = ({
  ageHistHetData,
  ageHistHomData,
  nonpar,
  isMito,
  gnomadType,
  filterFailed,
}) => {
  const ageHistHetRes = createHistogram(ageHistHetData, "HET");
  const ageHistHomRes = createHistogram(ageHistHomData, "HOM");
  const {
    data: ageHistHet,
    empty: ageHistHetEmpty,
    total: ageHistHetTotal,
  } = ageHistHetRes;
  const {
    data: ageHistHom,
    empty: ageHistHomEmpty,
    total: ageHistHomTotal,
  } = ageHistHomRes;

  return ageHistHetRes.empty && ageHistHomRes.empty ? (
    ""
  ) : (
    <div
      data-testid="histograms"
      className={`${filterFailed ? "tw-opacity-30" : ""}`}
    >
      <div className="varsome-horiz-list-label tw-text-center tw-p-5">
        <h5>
          <b>Age Distribution</b>
        </h5>
      </div>
      {!ageHistHetEmpty && (
        <div className="tw-inline-block">
          <div className="varsome-horiz-list-label tw-text-center tw-p-5">
            <h5>
              <b>{isMito ? "Heteroplasmic" : "Heterozygotes"}</b>
            </h5>
          </div>
          <GnomadHistogram
            data={ageHistHet}
            total={ageHistHetTotal}
            uniqueKey={`${gnomadType}_het`}
          />
        </div>
      )}
      <div className="tw-inline-block">
        <div className="varsome-horiz-list-label tw-text-center tw-p-5">
          <h5>
            <b data-testid="title-hom">
              {title(isMito, nonpar, ageHistHomEmpty)}
            </b>
          </h5>
        </div>
        {!ageHistHomEmpty ? (
          <GnomadHistogram
            data={ageHistHom}
            total={ageHistHomTotal}
            uniqueKey={`${gnomadType}_hom`}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

Histograms.propTypes = {
  nonpar: PropTypes.number,
  isMito: PropTypes.bool,
  gnomadType: PropTypes.string,
  filterFailed: PropTypes.bool,
  ageHistHetData: PropTypes.shape({}),
  ageHistHomData: PropTypes.shape({}),
};

Histograms.defaultProps = {
  nonpar: null,
  isMito: false,
  gnomadType: null,
  filterFailed: false,
  ageHistHetData: null,
  ageHistHomData: null,
};

export default Histograms;
